var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4.07,
    fill: "#4B57E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4.07,
    fill: "url(#paint0_linear_664_33933)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3586 16.8488L21.3586 18.8488C21.2648 18.9426 21.1376 18.9953 21.0049 18.9953C20.8722 18.9953 20.745 18.9426 20.6511 18.8488C20.5573 18.755 20.5046 18.6277 20.5046 18.495C20.5046 18.3623 20.5573 18.2351 20.6511 18.1413L21.798 16.995H16.2118L12.7118 20.495H14.5049C14.6375 20.495 14.7647 20.5477 14.8584 20.6415C14.9522 20.7352 15.0049 20.8624 15.0049 20.995C15.0049 21.1276 14.9522 21.2548 14.8584 21.3486C14.7647 21.4423 14.6375 21.495 14.5049 21.495H11.5049C11.3723 21.495 11.2451 21.4423 11.1513 21.3486C11.0576 21.2548 11.0049 21.1276 11.0049 20.995V17.995C11.0049 17.8624 11.0576 17.7352 11.1513 17.6415C11.2451 17.5477 11.3723 17.495 11.5049 17.495C11.6375 17.495 11.7647 17.5477 11.8584 17.6415C11.9522 17.7352 12.0049 17.8624 12.0049 17.995V19.7881L15.5049 16.2881V10.7019L14.3586 11.8488C14.2648 11.9426 14.1376 11.9953 14.0049 11.9953C13.8722 11.9953 13.745 11.9426 13.6511 11.8488C13.5573 11.755 13.5046 11.6277 13.5046 11.495C13.5046 11.3623 13.5573 11.2351 13.6511 11.1413L15.6511 9.14127C15.6976 9.09478 15.7527 9.0579 15.8134 9.03274C15.8741 9.00758 15.9392 8.99463 16.0049 8.99463C16.0706 8.99463 16.1357 9.00758 16.1964 9.03274C16.2571 9.0579 16.3122 9.09478 16.3586 9.14127L18.3586 11.1413C18.4525 11.2351 18.5052 11.3623 18.5052 11.495C18.5052 11.6277 18.4525 11.755 18.3586 11.8488C18.2648 11.9426 18.1376 11.9953 18.0049 11.9953C17.8722 11.9953 17.745 11.9426 17.6511 11.8488L16.5049 10.7019V15.995H21.798L20.6511 14.8488C20.5573 14.755 20.5046 14.6277 20.5046 14.495C20.5046 14.3623 20.5573 14.2351 20.6511 14.1413C20.745 14.0475 20.8722 13.9947 21.0049 13.9947C21.1376 13.9947 21.2648 14.0475 21.3586 14.1413L23.3586 16.1413C23.4051 16.1877 23.442 16.2429 23.4672 16.3036C23.4923 16.3643 23.5053 16.4293 23.5053 16.495C23.5053 16.5607 23.4923 16.6258 23.4672 16.6865C23.442 16.7472 23.4051 16.8023 23.3586 16.8488Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_33933",
    x1: 16.5,
    y1: 0,
    x2: 16.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B57E2",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.836a4f117b3c16e21d68e6f4eba04dc7.svg";
export { ForwardRef as ReactComponent };